export default __webpack_public_path__ + "static/media/insanityofxotli.cdee6a2f.png";